import { Link, useLocation, useNavigate } from "react-router-dom";
import "./css/RavookaHeader.css";
import RavookaLogo from "../assets/logo/Ravooka Logo - White.svg";
import { useState, useEffect } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import ShineButton from "../components/ShineButton";

const RavookaHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIfMobile();

    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  };

  const isActive = (path) => {
    return location.pathname === path ? "active-reelai" : "";
  };

  const handleContactClick = () => {
    navigate("/contact-us");
  };

  return (
    <>
      <header className="header-container-reelai">
        {isMobile && (
          <button
            className="menu-button-reelai"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <XMarkIcon className="menu-icon-reelai" />
            ) : (
              <Bars3Icon className="menu-icon-reelai" />
            )}
          </button>
        )}

        <div
          className={`logo-container-reelai ${
            isMobile ? "mobile-logo-reelai" : ""
          }`}
        >
          <Link to="/">
            <img src={RavookaLogo} alt="Ravooka Logo" className="logo-reelai" />
          </Link>
        </div>

        {!isMobile && (
          <>
            <nav className="nav-links-reelai">
              <Link to="/" className={`nav-link-reelai ${isActive("/")}`}>
                Home
              </Link>
              <Link
                to="/about-us"
                className={`nav-link-reelai ${isActive("/about-us")}`}
              >
                About Us
              </Link>
            </nav>
            <div className="header-actions-reelai">
              <ShineButton
                className="shine-btn--header-contact"
                text="Contact Us"
                onClick={handleContactClick}
                icon={null}
              />
            </div>
          </>
        )}
      </header>

      {/* Mobile Sidebar */}
      {isMobile && (
        <div
          className={`mobile-sidebar-reelai ${
            isMobileMenuOpen ? "open-reelai" : ""
          }`}
        >
          <div className="sidebar-header-reelai">
            <button
              className="close-menu-button-reelai"
              onClick={toggleMobileMenu}
              aria-label="Close menu"
            >
              <XMarkIcon className="close-icon-reelai" />
            </button>
          </div>

          <div className="sidebar-nav-container-reelai">
            <nav className="sidebar-nav-links-reelai">
              <Link
                to="/"
                className={`sidebar-nav-link-reelai ${isActive("/")}`}
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
              <Link
                to="/about-us"
                className={`sidebar-nav-link-reelai ${isActive("/about-us")}`}
                onClick={toggleMobileMenu}
              >
                About Us
              </Link>
            </nav>
            <div className="sidebar-footer-reelai">
              <ShineButton
                className="shine-btn--header-contact"
                text="Contact Us"
                onClick={() => {
                  handleContactClick();
                  toggleMobileMenu();
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && isMobile && (
        <div
          className="mobile-menu-overlay-reelai"
          onClick={toggleMobileMenu}
        ></div>
      )}
    </>
  );
};

export default RavookaHeader;
